import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { RichTextEditorComponent } from "@/app/components/shared/rich-textEditor/rich-textEditor.component";
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-rfp-applicant-clarification-create-query',
  standalone: true,
  imports: [
    RichTextEditorComponent,
    CommonModule,
  ],
  templateUrl: './rfp-applicant-clarification-create-query.component.html',
  styleUrl: './rfp-applicant-clarification-create-query.component.css'
})
export class RfpApplicantClarificationCreateQueryComponent {
  resetRichTextEditor = false;
  rfpQuery: string = '';
  rfpQueryControl = new FormControl('', Validators.required);

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly dialogData: any,
    private dialogRef: MatDialogRef<RfpApplicantClarificationCreateQueryComponent>,
    private tenderingService: TenderingService,
  ) { }

  updateQuery(content: string) {
    this.rfpQueryControl.setValue(content);
  }

  close(success: boolean = false) {
    this.dialogRef.close({ 'success': success })
  }

  prepareDataToSubmit() {
    if (!this.rfpQueryControl.valid) {
      console.log('invalid');
      return
    }
    const dataToSubmit = new FormData();
    dataToSubmit.append('query', this.rfpQueryControl.value);
    return dataToSubmit
  }

  /**
   * HTTP REQUESTS START
   */
  submitRFPQuery() {
    const data = this.prepareDataToSubmit()

    return this.tenderingService.storeRfpQuery(data, this.dialogData.projectId, this.dialogData.rfpId).subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          console.log(response);
          this.close(true)
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }
  /**
   * HTTP REQUESTS END
   */
}
